"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _shared = require("@clayui/shared");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["active", "children", "className", "disabled", "href", "innerProps", "onClick"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var Item = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    children = _ref.children,
    className = _ref.className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    href = _ref.href,
    _ref$innerProps = _ref.innerProps,
    innerProps = _ref$innerProps === void 0 ? {} : _ref$innerProps,
    onClick = _ref.onClick,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("li", _extends({}, otherProps, {
    className: (0, _classnames.default)('nav-item', className),
    role: "none"
  }), /*#__PURE__*/_react.default.createElement(_shared.LinkOrButton, _extends({}, innerProps, {
    "aria-selected": active,
    buttonDisplayType: "unstyled",
    buttonType: "button",
    className: (0, _classnames.default)('nav-link', {
      active: active,
      disabled: disabled
    }),
    disabled: disabled,
    href: href,
    onClick: onClick,
    ref: ref,
    role: "tab",
    tabIndex: !active ? -1 : 0
  }), children));
});
Item.displayName = 'ClayTabsItem';
var _default = exports.default = Item;